module.exports = __webpack_public_path__ + "static/media/29ADMSPC14.eeb5429d.jpg";